import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from '@angular/core';

@Component({
  selector: 'app-tab-button',
  standalone: true,
  imports: [],
  templateUrl: 'tab-button.component.html',
  styleUrl: 'tab-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabButtonComponent {
  isActive = input<boolean>(false);
  isDisabled = input<boolean>(false);
  iconClass = input<string | null>(null);
  @Output() tabClicked = new EventEmitter<MouseEvent>();
}
